import type { StateCreator } from 'zustand';
import type { GuidedDoctorConsultsActions, GuidedDoctorConsultsSliceType } from '../types';

export const setIsDirty: StateCreator<
  GuidedDoctorConsultsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  GuidedDoctorConsultsActions['setIsDirty']
> = (set) => {
  return (isDirty) => {
    set(
      (state) => {
        state.guidedDoctorConsult.isDirty = isDirty;
      },
      false,
      'guidedDoctorConsult/setIsDirty',
    );
  };
};
